var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgCalendarOutline20 = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 20,
  height: 20,
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M6 2C6.55228 2 7 2.44772 7 3H13C13 2.44772 13.4477 2 14 2C14.5523 2 15 2.44772 15 3C16.6569 3 18 4.34315 18 6V9V15C18 16.6569 16.6569 18 15 18H5C3.34315 18 2 16.6569 2 15V9V6C2 4.34315 3.34315 3 5 3C5 2.44772 5.44772 2 6 2ZM13 5C13 5.55228 13.4477 6 14 6C14.5523 6 15 5.55228 15 5C15.5523 5 16 5.44772 16 6V8H4V6C4 5.44772 4.44772 5 5 5C5 5.55228 5.44772 6 6 6C6.55228 6 7 5.55228 7 5H13ZM4 10H16V15C16 15.5523 15.5523 16 15 16H5C4.44772 16 4 15.5523 4 15V10Z",
  fill: "currentColor"
})));
export { SvgCalendarOutline20 as ReactComponent };